module.exports = __webpack_public_path__ + "img/ic_24_team_turnen.6522ee6b.svg";